import { Attachment } from './attachment';
import { CoordinatorService } from './coordinator.service';
import { ScriptBase } from './script-base';
import { ScriptHitset } from './script-hitset';
import { SELECTION_ROLE } from './script-types';
import { XItem } from './x-item';

export class ScriptAttachment extends ScriptBase {
    #coords: CoordinatorService;
    #_att: Attachment;

    url: string;
    description: string;

    constructor(coords: CoordinatorService, _att: Attachment) {
        super(coords, _att);
        this.#coords = coords;
        this.#_att = _att;

        this.url = this.#_att.url || '';
        this.description = this.#_att.description || '';
    }

    submit(targetId: string | string[]) {
        if (!Array.isArray(targetId)) targetId = [targetId];
        targetId.forEach((tId) => {
            const att = new Attachment(this.#coords, {
                values: {
                    title: this.title,
                    url: this.url,
                    description: this.description,
                },
                targetId: '_dummy',
            });
            att.assign(tId);
        });
        this.#coords.attachment$.markForManifestStore();
    }

    get idSet() {
        let test: Function;
        if (!this.url && !this.title)
            test = (x: XItem) => {
                return x.hasAttachment;
            };
        else
            test = (x: XItem) => {
                for (const a of this.#coords.attachment$.attachmentLs(x.id)) {
                    if (this.url && this.title && a.url == this.url && a.title == this.title)
                        return true;

                    if (this.url && a.url == this.url) return true;
                    if (this.title && a.title == this.title) return true;
                }
                return false;
            };

        const ls = this.#coords.dataset$.main.mainXitemLs.map((x) => {
            return test(x) && x.id;
        });

        return new Set<string>(ls.filter((x) => x) as string[]);
    }

    hitset() {
        const nH = new ScriptHitset(this.#coords);
        return nH;
    }

    json() {
        return this.#_att.save();
    }

    log() {
        console.log(
            'Attachment - title:',
            this.title,
            'url:',
            this.url,
            'description:',
            this.description,
        );
    }
}
